module.exports = __webpack_public_path__ + "fonts/dfda129.ttf";